import Chart from 'react-apexcharts';
import {
  useDsi,
} from '@src/modules/performance/context/reports-api-hooks';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import { Link, Text } from '@chakra-ui/react';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Annual DSI & Crashes Involving DSI',
  content: [
    {
      title: 'DSIs and Crashes',
      description:
  <>
    <Text fontSize="inherit" mb={2} fontWeight="bold">Total DSI</Text>
    <Text fontSize="inherit" mb={2}>
      The total count of deaths and serious injuries (DSIs) within the geographical area of the selected network.
      <br />
      Any difference between these totals and other totals in Transport Insights will be due to either when the data was processed from the Crash Analysis System (CAS) or because these figures include DSIs that occurred outside the road corridors managed by the selected RCA/s.
    </Text>
    <Text fontSize="inherit" mb={2} fontWeight="bold">Crashes involving DSI</Text>
    <Text fontSize="inherit">
      The total count of crashes involving DSIs within the geographical area of the selected network.
      <br />
      Any difference between these totals and other totals in Transport Insights will be due to either when the data was processed from CAS or because these figures include crashes that occurred outside the road corridors managed by the selected RCA/s.
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Crash data sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/partners/data-and-tools/crash-analysis-system" isExternal>NZTA Crash Analysis System.</Link>
    {' '}
    Road Efficiency Group Te Ringa Maimoa has calculated these results from these data sources.
  </Text>,
    },
  ],
};

function RoadSafetyDsi() {
  const { data, isLoading } = useDsi();
  const distinctYears = [...new Set(data?.map((item) => item.latestYear))];
  const lockYear = data?.[0]?.lockYear || null;
  const chartData = [
    {
      name: 'Total DSI',
      type: 'line',
      data: data?.map((item) => ({ x: item.latestYear, y: item.dsi })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Crashes involving DSI',
      type: 'line',
      data: data?.map((item) => ({ x: item.latestYear, y: item.totalCrashes })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="Annual DSI & Crashes Involving DSI"
      informationSource={informationSource}
      links={[
        {
          label: 'ONF Safe Travel - Deaths and Serious Injuries',
          url: '/onf/transport-outcomes/hsp1',
          isExternal: false,
          userRoles: null,
        },
      ]}
      isLoading={isLoading || !data}
      lockYear={lockYear}
    >
      <Chart
        options={{
          title: {
            text: 'DSIs and Crashes',
          },
          chart: {
            animations: {
              enabled: false,
            },
          },
          xaxis: {
            categories: distinctYears,
            labels: {
              offsetY: 5,
              rotate: -45,
              rotateAlways: true,
            },
          },
          yaxis: [
            {
              forceNiceScale: false,
            },
          ],
          grid: {
            padding: {
              left: 20,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
            width: distinctYears.length > 1 ? 2 : 0,
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
        }}
        series={chartData}
        type="line"
        width="100%"
        height="260"
      />
    </ReportSection>
  );
}

export default RoadSafetyDsi;
